import axiosInstance from './axiosInstance';

const sendMessage = async (data) => {
    const response = await axiosInstance.post('/contact', data);
    return response.data;
};

export default { sendMessage };